/* @flow */
import AuthActions from 'auth/AuthActions';
import Button from 'components/Button.jsx';
import Image from 'components/Image.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import MarketingContent from './MarketingContent.jsx';
import NotFoundPage from 'app/components/NotFoundPage.jsx';
import OrganizationProfile from 'entities/OrganizationProfile';
import PropTypes from 'prop-types';
import * as React from 'react';
import SchoolDetailView from './SchoolDetailView.jsx';
import SchoolTeacherList from './SchoolTeacherList.jsx';
import UnauthenticatedView from 'auth/components/UnauthenticatedView.jsx';
import { AvatarImages } from 'constants/AvatarConstants.js';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

import './styles/SchoolView.scss';

type State = {
  organizationProfile: ?OrganizationProfile,
  error: boolean,
};

class SchoolView extends React.Component<$FlowFixMeProps, State> {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static onEnter(
    nextState: RouterState,
    replaceWith: (location: LocationDescriptor) => void,
    callback: Function
  ) {
    AuthActions.checkLoggedInAndLoadAppData().then(() => callback(), () => callback());
  }

  state: State = {
    organizationProfile: null,
    error: false,
  };

  componentWillMount() {
    const params = this.props.params;
    this.loadOrganization(params.organizationId);
  }

  getJoinTransition = (school: ?Object) => {
    if (!school) {
      return () => {};
    }
    return this.transitionToJoinSchool.bind(this, school.id);
  };

  getSchoolImage = () => {
    // TODO return school image (not in entity ATM).
    return AvatarImages.ORG_AVATAR;
  };

  loadOrganization = (organizationId: number | string) => {
    OrganizationProfile.fetch({ id: organizationId }).then(
      organizationProfile => {
        this.setState({ organizationProfile });
      },
      () => {
        this.setState({ error: true });
      }
    );
  };

  transitionToJoinSchool = (organizationId: number) => {
    this.context.router.push(`/school/join/${organizationId}`);
  };

  render() {
    if (this.state.error) {
      return <NotFoundPage />;
    }

    const school = this.state.organizationProfile;

    return (
      <UnauthenticatedView {...this.props} className="SchoolView">
        {school ? (
          <div className="SchoolView-content">
            <div className="SchoolView-header">
              <Image className="SchoolView-header-logo" src={this.getSchoolImage()} />
              <h1 className="SchoolView-header-title">{school.getName()}</h1>
              <Button
                onClick={this.getJoinTransition(school)}
                level="secondary"
                className="SchoolView-header-joinButton"
                eventElementName="SchoolView-header-joinButton">
                Join a class on Remind
              </Button>
            </div>
            <div className="SchoolView-body">
              <div className="SchoolView-body-teacherList">
                <SchoolTeacherList
                  location={this.props.location}
                  redirect={this.getJoinTransition(school)}
                  organizationId={school.id}
                  schoolName={school.getName()}
                  teachers={school.getTeachers()}
                />
              </div>

              <div className="SchoolView-body-details">
                <SchoolDetailView organizationProfile={school} />
              </div>
            </div>
          </div>
        ) : (
          <LoadingIndicator className="SchoolView-loading" />
        )}
        <MarketingContent onSignupButtonClick={this.getJoinTransition(school)} />
      </UnauthenticatedView>
    );
  }
}

export default SchoolView;
